import axios, { AxiosRequestConfig } from "axios";
import { getAxiosInstance, requestConfig } from "../../http-common";
import { ExtractCreateRequest } from "../../models/extraction/ExtractCreateRequest";
import { ExtractUpdateRequest } from "../../models/extraction/ExtractUpdateRequest";

const RESOURCE_NAME = "extract";

const extract = (file: File, destinationTableId: number) => {
  const http = getAxiosInstance();
  const formData = new FormData();
  formData.append("file", file);
  formData.append("destinationTableId", destinationTableId?.toString() ?? "-1");

  return http.post(`${RESOURCE_NAME}/extractReact`, formData, requestConfig());
};

const extractSharePoint = (fileId: string, folderRelativePath: string, projectSourceId: number, destinationTableId: number,) => {
  const http = getAxiosInstance();
  const formData = new FormData();
  formData.append("fileId", fileId);
  formData.append("folderRelativePath", folderRelativePath);
  formData.append("projectSourceId", projectSourceId?.toString());
  formData.append("destinationTableId", destinationTableId?.toString());

  return http.post(`${RESOURCE_NAME}/extractSharePointFile`, formData, requestConfig());
}

const extractFileFromRepository = (path: string, destinationTableId: number) => {
  const http = getAxiosInstance();
  const formData = new FormData();
  formData.append("path", path);
  formData.append("destinationTableId", destinationTableId?.toString());

  return http.post(`${RESOURCE_NAME}/extractFileFromRepository`, formData, requestConfig());
}

const create = (model: ExtractCreateRequest) => {
  const http = getAxiosInstance();
  const data = new FormData();
  data.append("file", model.file);
  data.append("Entity", model.entity);
  data.append("GroupCode", model.groupCode);
  data.append("Database", model.database);
  data.append("Schema", model.schema);
  data.append("Table", model.table);
  data.append("Fields", model.fields);
  data.append("Keys", model.keys);
  
  if (model.systemId) {
    data.append("SystemId", model.systemId.toString()); 
  }

  return http.post(`${RESOURCE_NAME}/create`, data, requestConfig());
};

const update = (model: ExtractUpdateRequest) => {
  const http = getAxiosInstance();
  const data = new FormData();
  data.append("file", model.file);
  data.append("Fields", model.fields);
  data.append("SourceTableId", model.fromTableId);
  data.append("DestinationTableId", model.targetTableId);
  data.append("Operation", model.operationType);
  data.append("ExistingFields", model.existingFields);
  data.append("Keys", model.keys);

  return http.post(`${RESOURCE_NAME}/update`, data, requestConfig());
};

const getTables = (model: any = null) => {
  const http = getAxiosInstance();
  let request: any;
  if (!model) {
    request = {
      projectSourceId: model?.projectSourceId.toString()
    };
  } else {
    request = model;
  }
  return http.post(
    `${RESOURCE_NAME}/sqlserver/tables`,
    request,
    requestConfig()
  );
};

const getFields = (projectSourceId: number, tableName: any) => {
  const http = getAxiosInstance();
  const model = {
    projectSourceId: projectSourceId,
    tableName: tableName,
  };

  return http.post(`${RESOURCE_NAME}/sqlserver/fields`, model, requestConfig());
};
const getFieldsFromQuery = (query: string) => {
  const http = getAxiosInstance();
  const model = {
    query: query,
  };

  return http.post(`${RESOURCE_NAME}/sqlserver/fieldsFromQuery`, model, requestConfig());
};


const executeQuery = (
  tableName: any,
  selectedTop: any,
  fields: any,
  filter: any,
  groupBy: any,
  orderBy: any
) => {
  const http = getAxiosInstance();
  const model = {
    tableName: tableName,
    selectTop: selectedTop,
    fields: fields,
    filter: filter,
    groupBy: groupBy,
    orderBy: orderBy,
  };

  return http.post(
    `${RESOURCE_NAME}/sqlserver/execute`,
    model,
    requestConfig()
  );
};

const downloadQuery = (
  tableName: any,
  selectedTop: any,
  fields: any,
  filter: any,
  groupBy: any,
  orderBy: any
) => {
  const http = getAxiosInstance();
  const model = {
    tableName: tableName,
    selectTop: selectedTop,
    fields: fields,
    filter: filter,
    groupBy: groupBy,
    orderBy: orderBy,
  };

  let config: AxiosRequestConfig = requestConfig();
  config.responseType = 'blob';

  return http.post(
    `${RESOURCE_NAME}/sqlserver/download`,
    model,
    config
  );
};

const testConnection = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/sqlserver/test`, model, requestConfig());
};

const testFileRepositoryConnection = (path: string) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/testFileRepositoryConnection?path=${path}?`, requestConfig());
};

const getFileNamesFromRepository = (path: string) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getFileNamesFromRepository?path=${path}`, requestConfig())
};

const getSharePointFiles = (folderRelativePath: string, projectSourceId: string) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getSharePointFiles?folderRelativePath=${folderRelativePath}&projectSourceId=${projectSourceId}`, requestConfig())
};

const testSharePointConnection = (projectSourceId: string, sharePointSiteUrl: string, tenantId: string, clientId: string, username: string, password: string) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/testSharePointConnection?sharePointSiteUrl=${sharePointSiteUrl}&tenantId=${tenantId}&clientId=${clientId}&username=${username}&password=${password}&projectSourceId=${projectSourceId}`, requestConfig());
};

const extractSharePointProcess = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/extractSharepoint`, model, requestConfig());
};

const extractMsSql = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/extractMsSql`, model, requestConfig());
};


const extractFileRepository = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/extractFileRepository`, model, requestConfig());
}

const ExtractionService = {
  extract,
  create,
  update,
  getTables,
  getFields,
  getFieldsFromQuery,
  executeQuery,
  downloadQuery,
  testConnection,
  testFileRepositoryConnection,
  getFileNamesFromRepository,
  getSharePointFiles,
  testSharePointConnection,
  extractSharePoint,
  extractSharePointProcess,
  extractMsSql,
  extractFileRepository,
  extractFileFromRepository
};
export default ExtractionService;
